import fetch from "_fetch";

export default {
  JSON: 0,
  BINARY: 1,
  TEXT: 2,
  READER: 3,

  async download(path, controller, type, progressCallback = null) {
    const signal = controller.signal;
    const response = await fetch(path, {signal});
    if (!response.ok) {
      throw new Error("Couldn't load file: " + path);
    }

    const contentLength = response.headers ? +response.headers.get("Content-Length") : 0;
    let result;
    if (progressCallback && contentLength) {
      const reader = response.body.getReader();
      const fetchReader = async () => {
        let receivedLength = 0;
        let chunks = [];
        progressCallback(receivedLength / contentLength);
        for (; ;) {
          const {done, value} = await reader.read();

          if (done) {
            break;
          }

          chunks.push(value);
          receivedLength += value.length;

          progressCallback(receivedLength / contentLength);
        }

        const chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (const chunk of chunks) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }

        return chunksAll;
      }

      const mergedChunks = type === this.READER ? null : await fetchReader();
      switch (type) {
        case this.JSON:
          result = JSON.parse(new TextDecoder().decode(mergedChunks));
          break;
        case this.BINARY:
          result = mergedChunks.buffer;
          break;
        case this.TEXT:
          result = new TextDecoder().decode(mergedChunks);
          break;
        case this.READER:
          reader.byteLength = contentLength;
          result = reader;
          break;
      }
    } else {
      switch (type) {
        case this.JSON:
          result = await response.json();
          break;
        case this.BINARY:
          result = await response.arrayBuffer();
          break;
        case this.TEXT:
          result = await response.text();
          break;
        case this.READER:
          result = response.body.getReader();
      }
    }

    return result;
  },
}
